// extracted by mini-css-extract-plugin
export default {"help-icon":"styles_help-icon__YA38Q"};